//@ts-nocheck
"use client";

import { QueryClient } from "@tanstack/react-query";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import localforage from "localforage";
import { useState } from "react";
import { CLIENT_CACHE_BUSTER, CLIENT_CACHE_KEY } from "./lib/cache-tags";
import { useContentVersionSync } from "./lib/useContentVersionSync";

localforage.config({ name: "vxi-website", storeName: "query-cache" });

const makePersister = () =>
  createAsyncStoragePersister({
    storage: {
      getItem: (key) => localforage.getItem(key),
      setItem: (key, value) => localforage.setItem(key, value),
      removeItem: (key) => localforage.removeItem(key),
    },
    key: CLIENT_CACHE_KEY,
  });

// Never-expire browser cache: staleTime Infinity + 7d gcTime + IndexedDB
// persistence (7d cap: 30d overflows Node's 32-bit setTimeout). The snapshot
// renders instantly on revisit / tomorrow; fresh content arrives via
// background invalidation from useContentVersionSync.
function Inner({ children, queryClient }) {
  useContentVersionSync(queryClient);
  return <>{children}</>;
}

export default function Provider({ children, dehydratedState }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: Infinity,
            gcTime: 1000 * 60 * 60 * 24 * 7,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            refetchOnReconnect: false,
            retry: 1,
          },
        },
      })
  );
  const [persister] = useState(makePersister);

  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{ persister, buster: CLIENT_CACHE_BUSTER, maxAge: 1000 * 60 * 60 * 24 * 7 }}
      dehydratedState={dehydratedState}
    >
      <Inner queryClient={queryClient}>{children}</Inner>
    </PersistQueryClientProvider>
  );
}
